import { useMutation, useQuery } from '@tanstack/react-query';
import * as service from './corte-mora-service';
import { corteMoraKeys } from './keys';
import type { CorteMoraExportFormat, CorteMoraFilters, QueryCorteMora } from '@aid/shared';

export function useCorteMoraList(params: QueryCorteMora) {
  return useQuery({
    queryKey: corteMoraKeys.list(params as unknown as Record<string, unknown>),
    queryFn: () => service.getCorteMora(params),
    staleTime: 30_000,
  });
}

export function useCorteMoraStats(params: CorteMoraFilters) {
  return useQuery({
    queryKey: corteMoraKeys.stats(params as Record<string, unknown>),
    queryFn: () => service.getCorteMoraStats(params),
    staleTime: 30_000,
  });
}

export interface CorteMoraExportVariables {
  format: CorteMoraExportFormat;
  filters: CorteMoraFilters;
}

export function useExportCorteMora() {
  return useMutation({
    mutationFn: ({ format, filters }: CorteMoraExportVariables) =>
      service.exportCorteMora(format, filters),
  });
}
